import { render } from "./DepartmentRow.vue?vue&type=template&id=2a199dd6"
import script from "./DepartmentRow.vue?vue&type=script&lang=js"
export * from "./DepartmentRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__